// extracted by mini-css-extract-plugin
module.exports = {"background":"background_1TG5Z_","mijnProfiel":"mijnProfiel_3zNg3R","wrapper":"wrapper_3I5viE"};